import {TResponse, TUUID} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../../ws';
import {TBeneficiary} from './types';
import {getBeneficiary} from './mock';

import {
  ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_ADD,
  ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_GET
} from '../../../../../constants/api';

// Добавление бенефициара
// (у одного мерчанта может быть только один "бенефициар",
// как только добавляется новый старый лочится)
export function apiAdminPayoutNiumBeneficiaryAdd(params: Partial<TBeneficiary>): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_ADD;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Возвращает активную конфигурацию бенефициара для указанного мерчанта
export function apiAdminPayoutNiumBeneficiaryGet(params: {merchant_id: TUUID}): Promise<TBeneficiary> {
  const url = ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_GET;

  if (process.env.MOCK) {
    const response = getBeneficiary();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}
